var animations = (function () {

	let elements = [];

	function setup() {
		$('.animate-number').each(function (i, e) {
			elements[elements.length] = { top: $(e).offset().top, elem:e, started:false };
		});

		$(window).on('scroll', function () {
			//e.offset().top - $(window).scrollTop() - $(window).height()
			for (let i = 0; i < elements.length; i++) {
				if (!elements[i].started && elements[i].top - $(window).scrollTop() - $(window).height() < 0) {
					elements[i].started = true;
					animate($(elements[i].elem));
				}

				if (elements[i].started && elements[i].top - $(window).scrollTop() - $(window).height() > 50) {
					elements[i].started = false;
				}
			}
		});
	}

	function animate(e) {
		let stat = Number($(e).data('stat-val'));
		let span = $(e).find('span');
		for (let i = 0; i <= 40; i++) {
			let j = Math.round(i * (stat/40)).toLocaleString();
			span.text(j);
			window.setTimeout(function () { span.text(j); }, i * 30);
		}
		window.setTimeout(function () { span.text(stat.toLocaleString()); }, 40 * 30);
	}

	return {
		init: function () {
			$(function () {
				setup();
			});
		}
	};
})();

export var animations;